import { useEffect } from "react";

export function useScrollToTopOnChange<T>(dependency: T): void {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [dependency]);
}
